import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import { GetClientGroupDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ClientGroupSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  emptyGridMessage?: string;
}

export const clientGroupForGrid = (group: GetClientGroupDto): GridRecord => ({
  key: group.id,
  values: {
    'clientGroup.systemNumber': group.systemNumber,
    'clientGroup.name': group.name,
    'clientGroup.description': group.description
      ? group.description.length > 100
        ? group.description.slice(0, 100) + '...'
        : group.description
      : '',
  },
  isInactive: !group.active,
});

export const ClientGroupSearch: React.FC<ClientGroupSearchProps> = props => {
  const { t, tk } = useTranslation('clientLng');

  const columns: GridColumn[] = [
    { header: t(tk.common.sysNumber), property: 'clientGroup.systemNumber' },
    { header: t(tk.common.name), property: 'clientGroup.name' },
    { header: t(tk.common.description), property: 'clientGroup.description' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="clientGroup.systemNumber"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={
        props.emptyGridMessage ?? t(tk.clientGroup.noClientGroups)
      }
      onRowClick={props.onRowClick}
      refresh={props.refresh}
      withHistory={true}
      showExport={true}
      withFilterInColumns={true}
    />
  );
};
